import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import TableAlt from "../components/elements/table/TableAlt";
import ListLayout from "../containers/ListLayout";
import { postData } from "../services/api";


import toastr from "toastr";

import { API_URL } from "../config/host";
import ManageCarTypes from "../components/modals/ManageCategory";
import { useNavigate } from "react-router-dom";
import { setTitle } from "../helpers/MetaTag";

export default function CarTypes() {
  setTitle("Ryen bilpleie  | Car Types")
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [dateRange, setDateRange] = useState({});
  const [list, setList] = useState({
    loading: false,
    data: [],
    count: 0,
  });
  const [statusFilterData, setStatusFilterData] = useState([
    { _id: 1, name: "Active", type: "checkbox", value: true, isChecked: false },
    {
      _id: 2,
      name: "Inactive",
      type: "checkbox",
      value: false,
      isChecked: false,
    },
  ]);
  const [sortField, setSortField] = useState(null);
  const [sortType, setSortType] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    // if (user?._id) {
    const loadData = async () => {
      setList((list) => ({ ...list, loading: true }));
      const searchParams = {};
      if (keyword) {
        searchParams.title = { $regex: keyword, $options: "i" };
      }

      if (
        statusFilterData.filter((item) => item.touched && item.isChecked).length
      ) {
        searchParams.status = {
          $in: statusFilterData
            .filter((item) => item.touched && item.isChecked)
            .map((item) => item.value),
        };
      }
      if (dateRange.start && dateRange.end) {
        searchParams.created_at = {
          $gte: new Date(dateRange.start),
          $lte: new Date(dateRange.end),
        };
      }

      const res = await postData("/crud/list", {
        table_name: "carType",
        dateRange,
        queryParams: {
          deleted_at: null,
          ...searchParams,
        },
        selectParams: {
          title: true,
          status: true,
          image: {
            $cond: ["$image", { $concat: [API_URL, "$image"] }, null],
          },
          ordering: true,
          created_at: true,
        },
        sortQuery:
          sortField && sortType ? { [sortField]: sortType } : { ordering: 1 },
        limit,
        offset
      });
      if (res.status === 200) {
        setList((list) => ({
          ...list,
          data: res.data.list,
          loading: false,
          count: res.data.count,
        }));
      } else {
        setList((list) => ({ ...list, loading: false }));
      }
    };

    loadData();
    // }
  }, [
    user?._id,
    keyword,
    limit,
    offset,
    sortField,
    sortType,
    dateRange,
    statusFilterData.filter((item) => item.touched && item.isChecked).length,
  ]);



  const Appointments = (id) => {
    navigate(`/appoinments?car_type_id=${id}`);
  };

  const tableHeadData = [
    {
      width: 15,
      title: "Car Types",
      name: "title",
      align: "left",
      sortable: true,
      filterable: false,
    },
    {
      width: 15,
      title: "Created At",
      name: "created_at",
      align: "left",
      sortable: true,
      dateFilterable: true,
      onDateChange: (e) => {
        if (e && e.length && e.length > 1) {
          setDateRange({
            start: e[0],
            end: e[1],
          });
        }
      },
    },
    {
      width: 15,
      title: "Status",
      name: "status",
      align: "left",
      sortable: true,
      filterable: true,
      filterOptions: statusFilterData,
      onFilterChange: (id) => {
   
        setStatusFilterData((data) =>
          data.map((item) =>
            item._id !== id
              ? item
              : {
                  ...item,
                  isChecked: !item.isChecked,
                  touched: true,
                }
          )
        );
      },
    },
    {
      action: true,
    },
  ];
  const changeStatus = async (id) => {
    const res = await postData("/crud/statusChange", {
      table_name: "carType",
      id: [id],
      column_name: "status",
      column_value: !(
        list.data.find((item) => item._id === id).status || false
      ),
    });

    if (res.status === 200) {
      setList((list) => ({
        ...list,
        data: list.data.map((item) =>
          item._id !== id
            ? item
            : {
                ...item,
                status: !(
                  list.data.find((item) => item._id === id).status || false
                ),
                touched: true,
              }
        ),
        
      }));
      toastr.success(res.message)
    } else {
      toastr.error(res.message);
    }
  };

  const actionData = (item) => [
    {
      name: "Edit",
      icon: "fa-pen-to-square",
      type: "button",
      onClick: (id) => {
        setShowModal(true);
        setEditData(list.data.find((item) => item._id === id) || {});
      },
    },
    {
      name: item.status ? "Inactive" : "Active",
      icon: item.status ? "fa-circle-exclamation" : "fa-circle-check",
      type: "button",
      onClick: changeStatus,
    },
    {
      name: "Delete",
      icon: "fa-trash-can",
      type: "button",
      actionType: "delete",
      deleteLink: "/crud/delete",
      deletePayload: { id: [item._id], table_name: "carType" },
    },
    {
      name: "Appointments",
      icon: "fa-light fa-fw fa-solid fa-calendar-days",
      type: "button",
      onClick: (id) => Appointments(id),
    },
  ];
  const onDrag = async (data = []) => {
    const res = await postData("/crud/ordering", {
      table_name: "carType",
      ordering_data: data.map((item, i) => ({ id: item._id, ordering: i })),
    });

    if (res.status === 200) {
      toastr.success(res.message);
    }
  };
  // console.log(Math.ceil(list.count / limit),"cartypes")
  console.log(list,"cartypes")


  return (
    <>
      <ListLayout
        title="Car Types"
        addName="Add Car Type"
        onAdd={() => setShowModal(true)}
        limit={limit}
        setLimit={setLimit}
        setKeyword={setKeyword}
        keyword={keyword}
        noOfPage={Math.ceil(list.count / limit)}
        onPageChange={(val) => setOffset(val.selected * limit)}
        setOffset={setOffset}
      >
        <TableAlt
          tableHeadData={tableHeadData}
          tableData={list.data}
          loading={list.loading}
          sortField={sortField}
          sortType={sortType}
          setSortField={setSortField}
          setSortType={setSortType}
          actionData={actionData}
          setList={setList}
          isDraggable={true}
          onDrag={onDrag}
          functions={changeStatus}
        />
      </ListLayout>
      <ManageCarTypes
        show={showModal}
        setShow={setShowModal}
        title={
          Object.keys(editData).length > 0 ? "Edit Car Type" : "Add Car Type"
        }
        list={list.data}
        setList={setList}
        editData={editData}
        setEditData={setEditData}
      />
    </>
  );
}
